import Icon from '../components/Icon.vue'

Icon.register({
  'sort-amount-down': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M304 416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h64zM176 352c14.2 0 21.3 17.3 11.3 27.3l-80 96c-2.6 2.6-7.7 4.7-11.3 4.7-3.7 0-8.7-2.1-11.3-4.7l-80-96c-10.1-10.1-2.9-27.3 11.3-27.3h48v-304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v304h48zM432 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-192c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h192zM368 288c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-128c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h128zM496 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-256c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-amount-down.js
// module id = 1923
// module chunks = 0